import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../common/components/form/form.module'




export default function OnespInfoComponent({ handleInnerFormChange, selectedOnesp,  }: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>



            <InputContainer
              label=" ONE Service Provider Login Verified"
              name="IsONEServiceProviderLoginVerified"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'ONEServiceProviderInfo.IsONEServiceProviderLoginVerified',
                  selectedOnesp?.ONEServiceProviderInfo
                )
              }}
              type="checkbox"
              value={selectedOnesp?.ONEServiceProviderInfo?.IsONEServiceProviderLoginVerified}
            />

        
            <InputContainer
              label="Remarks"
              name="Remarks"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ONEServiceProviderInfo.Remarks',
                  selectedOnesp?.ONEServiceProviderInfo
                )
              }}
              type="text"
              value={selectedOnesp?.ONEServiceProviderInfo?.Remarks}
            />

            






          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Onesp Info"
      />

    </>
  )
}